import { render, staticRenderFns } from "./FormularioRevisao.vue?vue&type=template&id=3cacba27"
import script from "./FormularioRevisao.vue?vue&type=script&lang=js"
export * from "./FormularioRevisao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports